/** API host used by configurable tabular CRUD pages. */
export const CRUD_API_BASE = {
  CORE: 'CORE',
  PRODUCTS: 'PRODUCTS',
  SURVEY: 'SURVEY',
  SOURCING: 'SOURCING',
  LOAN_APP: 'LOAN_APP',
  HRMS: 'HRMS',
};

/** Built-in row-action keys. Extra keys (e.g. manage) are allowed via config. */
export const CRUD_ACTION = {
  UPDATE: 'update',
  DELETE: 'delete',
};

export const CRUD_COLUMN_TYPE = {
  TEXT: 'text',
  ELLIPSIS: 'ellipsis',
  DATETIME: 'datetime',
  COPYABLE: 'copyable',
  TITLE_SUBTITLE: 'titleSubtitle',
};

export const CRUD_FIELD_TYPE = {
  INPUT: 'input',
  TEXTAREA: 'textarea',
  NUMBER: 'number',
  SELECT: 'select',
  TREE_SELECT: 'treeSelect',
};

export const CRUD_FILTER_TYPE = {
  SELECT: 'select',
  TREE_SELECT: 'treeSelect',
};

export const CRUD_ACTION_VIEW = {
  REPLACE: 'replace',
};
